import { useContext, useEffect, useState } from 'react';
import { AuthContext } from 'context';
import { Form, Formik } from 'formik';
import { useHistory } from 'react-router-dom';
import ButtonComponent from 'components/design-system/Button/Button';
import { AlertaError } from 'utils/Alertas';
import { Close } from '@mui/icons-material';
import { DICTONARY } from 'const/Dictonary';
import { Dialog, DialogActions, DialogContent, Hidden } from '@mui/material';
import { ModalTransaccionesFormik } from './ModalTransaccionesFormik';
import { PERMISOS } from 'const/Permisos';
import { SchemaTrasaccion } from 'views/Transaccion/schema/SchemaTrasaccion';
import { formateaFechaDate, formateaSucursales } from 'views/Transaccion/utils';
import serviceRSD from 'services/residuos';
import empresasServices from 'services/empresas';

export const ModalTransacciones = ({
  openModal,
  transaccionSelected,
  handleCloseModal
}) => {
  const {
    perfiles: {
      isSuperAdmin,
      isAdmin,
      isAnalistaTerritorial,
      isRecicladorDeBase,
      isOferente,
      isDemandante,
      isAsesorCircularidad
    },
    logeduser,
    sucursalNoAdministrada,
    isTienePermisos
  } = useContext(AuthContext);
  const history = useHistory();
  const [listadoTiposTransporte, setListadoTiposTransporte] = useState([]);
  const [listadoEmpresasGestor, setListadoEmpresasGestor] = useState([]);
  const [listadoEmpresasAsesor, setListadoEmpresasAsesor] = useState([]);
  const [listadoEmpresasTransportista, setListadoEmpresasTransportista] =
    useState([]);
  const [listadoTiposTratamiento, setListadoTiposTratamiento] = useState([]);

  useEffect(() => {
    // const queryEmpresa = {
    //   totalPagina: DICTONARY.PAGINACION.ALL_DATA
    // };

    // Servicio Tipo de Transporte
    const obtenerTiposTransporte = async () => {
      if (transaccionSelected) {
        try {
          const response = await empresasServices.obtenerTipoTransaporte(
            null,
            null,
            null,
            DICTONARY.INTERCEPTOR.DESACTIVADO
          );
          const content = response.data.content;
          setListadoTiposTransporte(content);
        } catch (error) {
          console.log(error);
          setListadoTiposTransporte([]);
        }
      }
    };

    // Llamadas a funciones Gestor, Asesor, Transportista
    obtenerTiposTransporte();

    const obtenerEmpresasPorRol = (codigoRol, callback) => {
      if (transaccionSelected) {
        try {
          const query = {
            codigoRol
          };
          empresasServices
            .obtenerListaSucursales(
              query,
              null,
              null,
              null,
              DICTONARY.INTERCEPTOR.DESACTIVADO
            )
            .then(response => {
              const { data, error } = response;

              // Verificamos si data existe y es un array antes de hacer map
              if (error || !Array.isArray(data) || data.length === 0) {
                return callback([]);
              }

              // Si data es un array, hacemos map
              callback(
                data.map(sucursal => ({
                  codigoSucursal: sucursal.codigoSucursal,
                  nombreSucursal:
                    sucursal.nombreSucursal +
                    ' - ' +
                    sucursal.empresa.nombreEmpresa,
                  desdeServicio: true,
                  empresa: sucursal.empresa
                }))
              );
            })
            .catch(error => {
              callback([]);
              console.error('Error al obtener sucursales:', error);
            });
        } catch (error) {
          callback([]);
          console.error('Error en obtenerEmpresasPorRol:', error);
        }
      }
    };

    if (
      isSuperAdmin ||
      isDemandante ||
      isTienePermisos(PERMISOS.administracionSucursales) ||
      isAsesorCircularidad
    ) {
      obtenerEmpresasPorRol(
        DICTONARY.VALIDACION_ROLES.TRANSPORTISTA.CODIGO,
        setListadoEmpresasTransportista
      );
      obtenerEmpresasPorRol(
        DICTONARY.VALIDACION_ROLES.GESTOR.CODIGO,
        setListadoEmpresasGestor
      );
      obtenerEmpresasPorRol(
        DICTONARY.VALIDACION_ROLES.ASESOR.CODIGO,
        setListadoEmpresasAsesor
      );
    }
  }, [isAsesorCircularidad, isDemandante, isSuperAdmin, transaccionSelected]);

  useEffect(() => {
    if (transaccionSelected) {
      let params = {
        totalPagina: DICTONARY.PAGINACION.ALL_DATA,
        codigoTipoResiduo:
          transaccionSelected.residuo.tipoResiduo.codigoTipoResiduo
      };

      empresasServices
        .obtenerTipoTratamiento(params, DICTONARY.INTERCEPTOR.DESACTIVADO)
        .then(response => {
          const content = response.data.content;
          setListadoTiposTratamiento(content);
        })
        .catch(error => {
          console.log(error);
          setListadoTiposTratamiento([]);
        });
    }
  }, [transaccionSelected]);

  // SOLO PARA DEMANDANTES - erminar y aprobar de usuario
  const handleCerrarTransaccion = values => {
    let data = JSON.parse(JSON.stringify(values));

    let {
      sucursalAsesor,
      sucursalGestor,
      sucursalTransportista,
      ejecutoTratamiento,
      tipoTransporte,
      tipoTratamiento,
      fechaRecepcion,
      rutTransportista,
      patenteTransportista
    } = data;

    const formatoSucursalesTr = formateaSucursales(
      transaccionSelected.sucursalTransaccion,
      ejecutoTratamiento
    );
    const formatoAsesor = sucursalAsesor
      ? formatoSucursal(sucursalAsesor, 'asesor', ejecutoTratamiento)
      : null;
    const formatoGestor = sucursalGestor
      ? formatoSucursal(sucursalGestor, 'gestor', ejecutoTratamiento)
      : null;
    formatoAsesor && formatoSucursalesTr.push(formatoAsesor);
    formatoGestor && formatoSucursalesTr.push(formatoGestor);

    if (
      sucursalTransportista &&
      sucursalTransportista.codigoSucursal &&
      sucursalTransportista.codigoSucursal !== 0
    ) {
      const formatoTransportista = sucursalTransportista
        ? formatoSucursal(
            sucursalTransportista,
            'transportista',
            ejecutoTratamiento
          )
        : null;
      formatoTransportista && formatoSucursalesTr.push(formatoTransportista);
    }

    const dataFormateada = {
      fechaRecepcion: formateaFechaDate(fechaRecepcion), // Obligatorio
      tipoTransporte: {
        // Obligatorio
        codigoTipoTransporte: tipoTransporte.codigoTipoTransporte
      },
      tipoTratamiento: {
        // Obligatorio
        codigoTipoTratamiento: tipoTratamiento.codigoTipoTratamiento
      },

      transaccionEstado: [
        // Obligatorio
        {
          estado: {
            codigoEstado: DICTONARY.ESTADOS_TRANSACCION[2].CODIGO
          }
        }
      ],
      sucursalTransaccion: formatoSucursalesTr // Obligatorio
      // ejecutoTratamiento: ejecutoTratamiento
    };

    if (patenteTransportista) {
      Object.assign(dataFormateada, {
        patente: patenteTransportista
      });
    }

    if (rutTransportista) {
      Object.assign(dataFormateada, {
        rutEmpresaTransportista: rutTransportista
      });
    }

    console.log('DATA A ENVIAR PARA TERMINAR TRANSACCION >> ', dataFormateada);
    console.log('CERRAR TRANSACCIONES SERVICE');

    let codigoTransaccion = transaccionSelected.codigoTransaccion;
    serviceRSD
      .cerrarTransacciones(dataFormateada, codigoTransaccion)
      .then(result => {
        let stateTemp = {
          codigoTransaccion: codigoTransaccion,
          tipo: 'aprobar'
        };
        history.push({
          pathname: '/transacciones/resumen',
          state: stateTemp
        });
      })
      .catch(err => {
        console.log('ERROR AL CERRAR LA TRANSACCION:');
        console.error('err ::> ', err);
        AlertaError(
          'Ha ocurrido un error al tratar de cerrar la transacción. Por favor inténtelo más tarde.'
        );
      });
  };

  // SOLO PARA DEMANDANTES
  const formatoSucursal = (sucursal, nombreRol, ejecutoTratamiento) => {
    return {
      ejecutoTratamiento:
        ejecutoTratamiento && nombreRol === 'gestor' ? true : false,
      nombreRol: sucursal ? nombreRol : '',
      sucursal: { codigoSucursal: sucursal.codigoSucursal }
    };
  };

  return (
    <Formik
      initialValues={{
        tipoTratamiento: '',
        tipoTransporte: '',
        ejecutoTratamiento: '',
        fechaRecepcion: new Date(),
        sucursalGestor: '',
        sucursalAsesor: '',
        sucursalTransportista: '',
        rutTransportista: '',
        patenteTransportista: ''
      }}
      validateOnMount={true}
      validateOnChange={true}
      validationSchema={SchemaTrasaccion}
    >
      {({
        handleReset,
        values,
        errors,
        handleChange,
        handleBlur,
        touched,
        setFieldTouched,
        setFieldValue
      }) => (
        <Form className="w-full">
          <Dialog
            onClose={handleCloseModal}
            maxWidth="md"
            aria-labelledby="transition-modal-title"
            aria-describedby="transition-modal-description"
            open={openModal}
          >
            <DialogContent>
              <ModalTransaccionesFormik
                handleChange={handleChange}
                handleBlur={handleBlur}
                touched={touched}
                setFieldTouched={setFieldTouched}
                setFieldValue={setFieldValue}
                values={values}
                errors={errors}
                listadoTiposTransporte={listadoTiposTransporte}
                listadoEmpresasGestor={listadoEmpresasGestor}
                listadoEmpresasAsesor={listadoEmpresasAsesor}
                listadoEmpresasTransportista={listadoEmpresasTransportista}
                listadoTiposTratamiento={listadoTiposTratamiento}
              />
            </DialogContent>
            <DialogActions className="border-t border-neutral-90 p-4 justify-between">
              <ButtonComponent
                type="secondary"
                onClick={() => {
                  handleReset();
                  handleCloseModal();
                }}
                className="justify-center"
              >
                <Hidden smDown>Cancelar</Hidden>
                <Hidden smUp>
                  <Close />
                </Hidden>
              </ButtonComponent>
              <ButtonComponent
                type="primary"
                disabled={Object.keys(errors).length !== 0}
                onClick={() => {
                  handleCerrarTransaccion(values);
                }}
                autoFocus
                className="w-full xs:w-auto justify-center"
              >
                Cerrar transacción
              </ButtonComponent>
            </DialogActions>
          </Dialog>
        </Form>
      )}
    </Formik>
  );
};
